import { lazy } from 'react';

export const PDF = lazy(() => import('./PDF'));
